import { render, staticRenderFns } from "./modelcategory.vue?vue&type=template&id=32f28bc4&"
import script from "./modelcategory.vue?vue&type=script&lang=js&"
export * from "./modelcategory.vue?vue&type=script&lang=js&"
import style0 from "./modelcategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports